import { makeStyles } from "@material-ui/core/styles";

export default makeStyles(theme => ({
  root: {
    display: "flex",
    maxWidth: "100vw",
    overflowX: "hidden",
  },
  content: {
    flexGrow: 1,
    paddingInlineStart: "75px",
    padding: theme.spacing(1.5),
    paddingBlockStart: "76px",
    width: `calc(100vw - 240px)`,
    minHeight: "100vh",
    [theme.breakpoints.down("md")]: {
      paddingBlockStart: "94px",
    },
    [theme.breakpoints.down("xs")]: {
      paddingInlineStart: theme.spacing(1.5),
      paddingBlockStart: "82px",
    },
  },
  contentShift: {
    width: `calc(100vw - ${240 + theme.spacing(6)}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  fakeToolbar: {
    ...theme.mixins.toolbar,
    [theme.breakpoints.down("md")]: {
      minHeight: "82px",
    },
    [theme.breakpoints.down("xs")]: {
      minHeight: "70px",
    },
  },
}));
